import { render, staticRenderFns } from "./Amex.vue?vue&type=template&id=7f7edd94&scoped=true&"
import script from "./Amex.vue?vue&type=script&lang=js&"
export * from "./Amex.vue?vue&type=script&lang=js&"
import style0 from "./Amex.vue?vue&type=style&index=0&id=7f7edd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7edd94",
  null
  
)

export default component.exports